var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container,
    on: {
      "click": function click($event) {
        return _vm.$emit('edit');
      }
    }
  }, [_c('div', {
    class: _vm.$style.content
  }, [_c('div', {
    class: _vm.$style.title
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('div', {
    class: _vm.$style.action
  }, [_vm.isNew ? _c('span', {
    class: _vm.$style.icon
  }, [_c('circle-plus-icon')], 1) : [_c('span', {
    class: _vm.$style.icon,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('rename');
      }
    }
  }, [_c('pencil-edit-icon')], 1), _c('span', {
    class: _vm.$style.icon,
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.$emit('delete');
      }
    }
  }, [_c('trash-icon')], 1)]], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }